import { render, staticRenderFns } from "./InfopointStatus.vue?vue&type=template&id=6e6d234c&scoped=true"
import script from "./InfopointStatus.vue?vue&type=script&lang=js"
export * from "./InfopointStatus.vue?vue&type=script&lang=js"
import style0 from "./InfopointStatus.vue?vue&type=style&index=0&id=6e6d234c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d234c",
  null
  
)

export default component.exports